import { combineReducers } from 'redux';
import components from './components';
import outreach from './outreach';

export default combineReducers({
  components,
  outreach
});
